import * as Yup from 'yup';

export const VERIFY_MFA_VALIDATION_SCHEMA = Yup.object({
	code: Yup.string().required('You must enter your verification code.')
});
